import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getObjectItem, getTranslation, getPriceList } from '../../actions/dataActions'
import ReceiptLine from '../../components/ReceiptLine'
import * as types from '../../constants/Types'
import * as resource from '../../constants/Resources'

class ReceiptItem extends Component {

    constructor(props) {
        super(props);
        this.scrollContainerRef = React.createRef();
    }

    componentDidMount() {
        this.scrollToBottom();
    }

    componentDidUpdate(prevProps) {
        // Check if new lines were added
        if (prevProps.receipt && this.props.receipt && 
            prevProps.receipt.lines.length < this.props.receipt.lines.length) {
            setTimeout(() => this.scrollToBottom(), 100);
        }
    }

    scrollToBottom = () => {
        if (this.scrollContainerRef.current) {
            this.scrollContainerRef.current.scrollTop = this.scrollContainerRef.current.scrollHeight;
        }
    }

    render() {
        const { receipt, width, height, top, left, itemvalue } = this.props;
        const titleItems = [];

        let subTotal = 0;
        let title = '';
        let customerMessage = '';
        let priceListMessage = '';
        const functionType = parseInt(itemvalue, 10) || 0;
        if (functionType === 11) {
            if (receipt.receiptnumber) {
                titleItems.push(`#${receipt.receiptnumber}`);
            }
            if (receipt.orderNumber) {
                titleItems.push(`(order #${receipt.orderNumber})`);
            }
            if (receipt.pagerNumber) {
                titleItems.push(`${this.props.getTranslation(resource.PAGER)} #${receipt.pagerNumber}`);
            }
            if (receipt.objectitemid) {
                const objectItem = this.props.getObjectItem(receipt.objectitemid);
                if (objectItem !== null) {
                    titleItems.push(`${objectItem.ItemNumber}`);
                }
            }
            if (receipt.objectitemname && receipt.objectitemname !== '') {
                titleItems.push(`${receipt.objectitemname}`);
            }
            else if (receipt.objectitemdescription) {
                titleItems.push(`${receipt.objectitemdescription}`);
            }

            const priceList = this.props.getPriceList(receipt.pricelistid);
            if (priceList !== null) {
                priceListMessage = priceList.Description;
            }

            let receiptAge = receipt.age;
            var customerAge = (receiptAge !== null && receiptAge !== undefined) ? receiptAge : receipt.customer && receipt.customer.age;
            if (customerAge && customerAge !== 0) {
                customerMessage = `${this.props.getTranslation(resource.AGE)}: ${customerAge}`;
            }
            if (receipt.customer && receipt.customer.customerid > 0) {
                if (customerMessage.length > 0) {
                    customerMessage = `- ${customerMessage}`
                }
                customerMessage = `${receipt.customer.customerName} ${customerMessage}`;
                if (receipt.customer.customerSaldo !== 0.00) {
                    customerMessage = `${customerMessage} - ${this.props.getTranslation(resource.BALANCE)}: ${receipt.customer.customerSaldo.toFixed(2).replace('.', ',')}`;
                }
            }
        } else {
            receipt.lines.forEach(rec => {
                if (rec.linetype !== types.SUBTOTAL_LINE) {
                    subTotal += rec.price;

                    if (rec.discount) {
                        rec.discount.forEach(discountItem => {
                            // Discount price is negative
                            subTotal += discountItem.Price;
                        });
                    }
                }
            })

        }

        titleItems.map(item => {
            if (title !== '') {
                title = `${title} - `;
            }
            title = `${title}${item}`;

            return '';
        })

        let titleHeader;
        if (title && title !== '') {
            titleHeader = <div className='receiptItem_header'>{title}</div>
        } else {
            titleHeader = <div></div>
        }

        let priceListHeader;
        if (priceListMessage && priceListMessage !== '') {
            priceListHeader = <div className='receiptItem_header'>{priceListMessage}</div>
        } else {
            priceListHeader = <div></div>
        }

        let customerHeader;
        if (customerMessage && customerMessage !== '') {
            customerHeader = <div className='receiptItem_header'>{customerMessage}</div>
        } else {
            customerHeader = <div></div>
        }

        let style = {
            width: `${width}%`,
            height: `${height}%`,
            top: `${top}%`,
            left: `${left}%`,
            fontSize: `20px`,
        };
        if (functionType === 11) {
            style.position = "absolute";
            style.padding = "7px";
        }

        return (
            <div style={style} className="receiptItem">
                {titleHeader}
                {priceListHeader}
                {customerHeader}
                <div 
                    ref={this.scrollContainerRef}
                    className="receiptItem_lines" 
                    style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden' }}
                >
                    {functionType === 11 ? (<div></div>) : (receipt.lines.map(rec =>
                        <ReceiptLine
                            key={rec.id}
                            lineid={rec.id}
                            itemid={rec.itemid}
                            description={rec.text}
                            configuration={rec.configuration}
                            quantity={rec.quantity}
                            price={rec.price}
                            linetype={rec.linetype}
                            editable={rec.editable}
                            selected={rec.selected}
                            detailView={false}
                            discount={rec.discount}
                            simpleSeparator={rec.simpleSeparator}
                        />
                    ))}
                </div>
                {functionType === 10 ? (
                    <div className="receiptItem_subTotal">
                        <div className="subTotal">
                            {this.props.getTranslation(resource.SUB_TOTAL)}
                        </div>
                        <div className="price">
                            &euro;{subTotal.toFixed(2).replace('.', ',')}
                        </div>
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        receipt: state.receiptState.receipt
    }
}

export default connect(mapStateToProps, { getObjectItem, getTranslation, getPriceList })(ReceiptItem)


// WEBPACK FOOTER //
// src/freeformat/components/ReceiptItem.jsx